export default [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view"
  }
  // {
  //   icon: "el-icon-edit",
  //   label: "Editar klk",
  //   command: "Edit",
  //   disabled: true

  // },
  // {
  //   icon: "el-icon-plus",
  //   label: "Nueva negociacion",
  //   command: "new_deal",
  //   disabled: true
  // },
  // {
  //   icon: "el-icon-plus",
  //   label: "Nueva interaccion",
  //   command: "new_interaction"
  // },
  // {
  //   icon: "el-icon-plus",
  //   label: "Nueva solicitud",
  //   command: "new_request"
  // },
  // {
  //   icon: "el-icon-plus",
  //   label: "Crear contacto",
  //   command: "new_contact"
  // },
  // {
  //   icon: "el-icon-plus",
  //   label: "Crear reclamación",
  //   command: "new_complaint"
  // },
  // {
  //   icon: "el-icon-folder-opened",
  //   label: "ir a Documentos",
  //   command: "go_to_documents"
  // }
];
